import { boolean, InferType, object, string } from 'yup';

import { emailYupValidation, phoneYupValidation } from '../../../../../utils/validator';

const contactPersonFormSchema = object()
    .shape({
        first_name: string().trim().required('First name is required.'),
        last_name: string().trim().required('Last name is required.'),
        email: emailYupValidation,
        phone: phoneYupValidation,
        isDirty: boolean().default(false)
    })
    .defined();

export type ContactPersonFormSchemaParams = InferType<typeof contactPersonFormSchema>;

export { contactPersonFormSchema };
